import { ChangePasswordDialog } from "./change-password"
import { SignOutConfirmation } from "./sign-out-confirmaton"

export default { SignOutConfirmation, ChangePasswordDialog }
